/* Product page, above the fold (sections/main-product.liquid).
   - Variant tiles: pick the variant, update the hidden id, the legend, the help line, every
     price on the page ([data-pdp-price], a package's sauna row [data-pdp-part]), Add to cart
     (sold out / unavailable) and the URL (?variant=).
   - Quantity stepper, the "How it works" disclosure.
   - Gallery: the counter follows the slide in view; the track is a keyboard stop only where
     it scrolls (phones, 2+ images).
   - Desktop buy box: sticky under the header; when taller than the window it sticks by its
     bottom edge instead, so the pair line is never stranded below the fold.
   - Sticky mobile buy bar: shown while the in-flow Add to cart is out of view and the footer
     is not; toggles html.has-buybar (base.css moves the email slide-in above it).
   Prices are printed by Liquid (the money filter) into the JSON; nothing is formatted here.
   Adding to cart is vitalis.js's job (any form posting to /cart/add). */
(function () {
  "use strict";
  var d = document, html = d.documentElement;
  var desktop = window.matchMedia("(min-width: 1024px)");

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  function init(root) {
    if (!root || root.__pdp) return;
    root.__pdp = true;
    var sid = root.getAttribute("data-section-id");
    var scope = root.closest(".shopify-section") || root.parentNode;
    var data = {};
    try { data = JSON.parse(($("[data-pdp-json]", scope) || {}).textContent || "{}"); } catch (e) { data = {}; }
    var variants = data.variants || [];
    var form = d.getElementById("pdp-form-" + sid);
    var idInputs = form ? $$('input[name="id"]', form) : [];
    var bar = $("[data-pdp-buybar]", scope);
    var cleanups = [];

    /* ---- Variants ---- */
    function selected() {
      return $$("[data-vgroup]", root).map(function (g) {
        var c = $("input:checked", g);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setAtc(v) {
      var label = !v ? data.unavailable : v.available ? data.addLabel : data.soldOut;
      $$("[data-pdp-atc]", scope).forEach(function (b) {
        b.disabled = !v || !v.available;
        var l = $("[data-pdp-atc-label]", b);
        if (l && label) l.textContent = label;
      });
    }
    function onPick(input) {
      var g = input.closest("[data-vgroup]");
      var legend = g && $("[data-legend]", g);
      if (legend) legend.textContent = input.value;
      var help = g && $("[data-help]", g), notes = g && $("template[data-help-notes]", g);
      if (help && notes) {
        var key = input.value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
        var n = notes.content.querySelector('[data-value="' + key + '"]');
        help.textContent = n ? n.textContent : "";
      }
      var v = findVariant(selected());
      setAtc(v);
      if (!v) return;
      idInputs.forEach(function (el) { el.value = v.id; });
      /* Talk carries the configuration: "Title · Wood · Finish", as the mockup. */
      $$("[data-talk-pdp]").forEach(function (el) {
        el.setAttribute("data-about", [el.getAttribute("data-talk-pdp")].concat(v.options).join(" · "));
      });
      $$("[data-pdp-price]").forEach(function (el) { el.innerHTML = v.price; });   /* the buy box, the bar, a package's sum */
      if (v.part) $$("[data-pdp-part]").forEach(function (el) { el.innerHTML = v.part; });   /* a package's sauna, here and in Specifications */
      if (data.url && window.history && history.replaceState) {
        history.replaceState(history.state, "", data.url + "?variant=" + v.id + window.location.hash);
      }
    }
    root.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.matches && t.matches("[data-vgroup] input[type=radio]")) onPick(t);
    });

    /* ---- Quantity ---- */
    var qtyOut = $("[data-pdp-qty]", root), qtyIn = $("[data-pdp-qty-input]", root);
    root.addEventListener("click", function (e) {
      var step = e.target.closest && e.target.closest("[data-pdp-step]");
      if (step && qtyOut && qtyIn) {
        var q = Math.max(1, Math.min(99, (parseInt(qtyIn.value, 10) || 1) + parseInt(step.getAttribute("data-pdp-step"), 10)));
        qtyIn.value = q;
        qtyOut.textContent = String(q);
        $$("[data-pdp-step]", root).forEach(function (b) {
          var dir = parseInt(b.getAttribute("data-pdp-step"), 10);
          b.disabled = dir < 0 ? q <= 1 : q >= 99;
        });
        return;
      }
      var disc = e.target.closest && e.target.closest("[data-pdp-disc]");
      if (disc) {
        var panel = d.getElementById(disc.getAttribute("aria-controls"));
        var open = disc.getAttribute("aria-expanded") !== "true";
        disc.setAttribute("aria-expanded", String(open));
        if (panel) panel.hidden = !open;
      }
    });

    /* ---- Gallery ---- */
    var track = $("[data-gallery-track]", root), count = $("[data-gal-i]", root);
    if (track && count && "IntersectionObserver" in window) {
      var gio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) count.textContent = String(+en.target.getAttribute("data-i") + 1);
        });
      }, { root: track, threshold: [0.6] });
      $$(".gallery__slide", track).forEach(function (s) { gio.observe(s); });
      cleanups.push(function () { gio.disconnect(); });
    }
    function syncTrack() {
      if (!track) return;
      if (!desktop.matches && track.children.length > 1) track.setAttribute("tabindex", "0");
      else track.removeAttribute("tabindex");
    }

    /* ---- Desktop buy box ---- */
    var buy = $("[data-pdp-buy]", root);
    function headerBottom() {
      var h = $(".section-header") || $("header");
      return h ? Math.max(0, h.getBoundingClientRect().height) : 64;
    }
    function fit() {
      syncTrack();
      if (!buy) return;
      if (!desktop.matches) { buy.style.removeProperty("--buy-top"); return; }
      var top = headerBottom() + 40;
      var room = window.innerHeight - top - 24;
      buy.style.setProperty("--buy-top", (buy.offsetHeight > room ? Math.round(window.innerHeight - buy.offsetHeight - 24) : top) + "px");
    }
    fit();
    window.addEventListener("resize", fit);
    var ro = "ResizeObserver" in window && buy ? new ResizeObserver(fit) : null;
    if (ro) ro.observe(buy);
    cleanups.push(function () { window.removeEventListener("resize", fit); if (ro) ro.disconnect(); });

    /* ---- Buy bar ---- */
    var atc = form && $("[data-pdp-atc]", form);
    var ftr = d.getElementById("ftr");
    var st = { atc: true, ftr: false };
    function syncBar() {
      html.classList.toggle("has-buybar", !!bar && !st.atc && !st.ftr && !desktop.matches);
    }
    if (bar && atc && "IntersectionObserver" in window) {
      /* The in-flow button counts as "in view" only when it is whole; while it slides in
         under the bar, the bar keeps its own button on top, so one is always complete. */
      var bio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === atc) st.atc = en.isIntersecting && en.intersectionRatio > 0.98;
          else st.ftr = en.isIntersecting;
        });
        syncBar();
      }, { threshold: [0, 0.99, 1] });
      bio.observe(atc);
      if (ftr) bio.observe(ftr);
      cleanups.push(function () { bio.disconnect(); html.classList.remove("has-buybar"); });
    }
    var onMedia = function () { fit(); syncBar(); };
    if (desktop.addEventListener) desktop.addEventListener("change", onMedia);
    cleanups.push(function () { if (desktop.removeEventListener) desktop.removeEventListener("change", onMedia); });

    root.__pdpCleanup = function () { cleanups.forEach(function (f) { f(); }); root.__pdp = false; };
  }

  function boot(scope) { $$("[data-pdp]", scope).forEach(init); }
  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", function () { boot(d); });
  else boot(d);

  /* Theme editor: re-init a reloaded section, clean up an unloaded one. */
  d.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  d.addEventListener("shopify:section:unload", function (e) {
    $$("[data-pdp]", e.target).forEach(function (r) { if (r.__pdpCleanup) r.__pdpCleanup(); });
  });
})();
